// Overlay.js
import React from 'react';
import styled, { withTheme } from 'styled-components'
import { Text } from './Text';
import { Image } from './Image';

const OverlayContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

const OverlayContent = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.7); /* translucent white */
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: center;
  align-items: center;
  z-index: 2;
  border-radius: inherit; /* inherits parent border-radius if any */
`;

const Overlay = ({ children, message, theme, icon, textWidth }) => {
    return (
        <OverlayContainer>
            {children}
            {(icon || message) && (
                <OverlayContent>
                    {icon && <Image src={icon} />}
                    {message && (
                        <Text width={textWidth} center color={theme.colors.primary2}>
                            {message}
                        </Text>
                    )}
                </OverlayContent>
            )}
        </OverlayContainer>
    );
};

export default withTheme(Overlay);
